module.exports = __webpack_public_path__ + "static/media/icon_b.9f92547b.svg";